export default function createInitialValues(queryParams) {
  const COMMON = {
    tripType: 'R',
    // tripType for seconday radio input
    tripType2: 'R',
    pax: 1,
    arrivalDate: '',
    departureDate: '',
    fromLocation: 'Kathmandu',
    toLocation: 'Ramechhap',
  };
  
  const initialValues = {  ...COMMON };

  if (!queryParams && Object.keys(queryParams).length === 0)   return initialValues;
  
  let merged = {};

  for (let key in initialValues) {
    if (queryParams.hasOwnProperty(key)) {
      merged = { ...merged, [key]: queryParams[key] };
    } else {
      const defaultValue = initialValues[key];
      merged = { ...merged, [key]: defaultValue };
    }
  }

  return merged;
}


// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/createInitialValues.js